<template>
  <div>
    <div class="margin_container">
      <el-input
        v-model="borderRadius"
        width="32px"
      />
      <div class="view-radius">
        <span>效果</span>
        <div
          class="view-border"
          :style="{ borderTopLeftRadius: borderRadius + 'px' }"
        />
      </div>
    </div>
  </div>
</template>
<script>
import mixin from '@/view/weappTmp/core/lib/package/element-node-mixin.js'
export default {
  name: 'SpBorderRadius',
  mixins: [mixin],
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      borderRadius: ''
    }
  },
  watch: {},
  created () {},
  methods: {}
}
</script>
<style scoped lang="scss">
.margin_container {
  display: flex;
}
.margin_box {
  margin-right: 8px;
  text-align: center;
  .margin_box_text {
    margin-top: 4px;
  }
}
.view-radius {
  width: 120px;
  display: flex;
  align-items: center;
  margin-left: 20px;
}
.view-border {
  width: 35px;
  height: 35px;
  border: 1px solid #666;
  margin-left: 6px;
}
</style>
